// Copypasta from Redux
// Reference: https://github.com/reactjs/redux/blob/master/src/compose.js
export function compose(...funcs) {
  funcs = funcs.filter(func => typeof func === 'function');

  if (funcs.length === 0) {
    return arg => arg;
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce((a, b) => (...args) => a(b(...args)));
}



// WEBPACK FOOTER //
// ./src/shared/helpers/compose.js